import { Controller } from '@hotwired/stimulus'
import { empujaConversiones } from 'lib/conversiones_analiticas'

// Connects to data-controller="conversion-analitica". Ver lib/conversiones_analiticas.js.
export default class extends Controller {
  static values = { conversiones: Array, esperaAlConsentimiento: { type: Boolean, default: true } }

  connect () {
    empujaConversiones(this.conversionesValue, { esperaAlConsentimiento: this.esperaAlConsentimientoValue })
  }
}
